import { useState } from 'react'
import { config } from '../lib/config'

export function PlayerAvatar({
  uuid,
  username,
  size = 96,
  body = false,
  className = '',
}: {
  uuid: string
  username: string
  size?: number
  body?: boolean
  className?: string
}) {
  const identifier = encodeURIComponent(username.trim() || uuid)
  const source = body
    ? `${config.bodyRenderBaseUrl}/${identifier}`
    : `${config.avatarBaseUrl}/${identifier}/${Math.min(size, 512)}`
  const [failedSource, setFailedSource] = useState<string | null>(null)
  const failed = failedSource === source

  return (
    <img
      alt={`Avatar Minecraft di ${username}`}
      className={`player-avatar ${className}`.trim()}
      decoding="async"
      height={size}
      loading="lazy"
      onError={() => setFailedSource(source)}
      src={failed ? '/assets/player-placeholder.svg' : source}
      width={size}
    />
  )
}
